import { AuditeePermissionBean } from './auditee-permission-bean';
import { AuditeePermissionDeptWiseBean } from './auditee-permission-dept-wise-bean';
import { AuditorAuditeePermissionResponseBean } from './auditor-auditee-permission-response-bean';
export class AuditeePermissionDTO {
    auditId: string;
    userId: number;
    scopeItemId: number;
    actionType: string;
    deptId: number;
    roleId: number;
    roleName: string;
    roleType: string;
    auditeeIds: string;
    siteId: number;
    sectionCode: string;
    auditeePermissionBeanList: AuditeePermissionBean[];
    auditeePermissionDeptWiseBeanList: AuditeePermissionDeptWiseBean[];
    permissionResponseBeanList: AuditorAuditeePermissionResponseBean[];
}